export default {
  id: "franchise-roadmap",
  name: "Franchise Roadmap",
  shortName: "Roadmap",
  description: "Franchise onboarding roadmap & milestones",
  icon: "map",
  color: "#FBAF39",
  roles: ["super_admin", "admin", "corporate", "franchisee"],
  css: "styles/apps/franchise-roadmap.css",
  nav: [
    { id: "roadmap", label: "Roadmap" },
    { id: "progress", label: "Progress" },
    { id: "checklist", label: "Checklist" },
  ],
  defaultView: "roadmap",
};
